import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end",
    "data-kt-customer-table-toolbar": "base"
  })
], -1)
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex flex-center flex-wrap" }
const _hoisted_10 = {
  class: "alert alert-danger custom-slim-btn",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.breadcrumbs[1][$setup.breadcrumbs[1].length - 1]), 1)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Datatable, {
        ref: "tableRef",
        "table-header": $setup.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.loading,
        total: _ctx.total
      }, _createSlots({
        "cell-no": _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index + 1 + _ctx.rowsPerPage * (_ctx.currentPage - 1)), 1)
        ]),
        "cell-id": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.id.slice(16).toUpperCase()), 1)
        ]),
        "cell-store": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.store?.name || '-'), 1)
        ]),
        "cell-type": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.ServicesTypes.find((p) => p.value == row.package?.id)?.name || '-'), 1)
        ]),
        "cell-updatedAt": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.dateFormat(row.updatedAt, 'DD/MM/YYYY')), 1)
        ]),
        "cell-customer": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.customer?.name || '-'), 1)
        ]),
        "cell-payment": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.payment?.method || '-'), 1)
        ]),
        "cell-amountPrice": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString($setup.numberFormat(row.amountPrice)), 1)
        ]),
        "cell-details": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "btn btn-primary custom-slim-btn",
              onClick: ($event: any) => ($setup.confirmRefund(row.id)),
              "data-bs-toggle": "modal",
              "data-bs-target": "#refund-modal"
            }, " Refund ", 8, _hoisted_8)
          ])
        ]),
        "cell-status": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(row.status), 1)
          ])
        ]),
        _: 2
      }, [
        _renderList($setup.tableHeader.filter(
            (data) =>
              ![
                'id',
                'type',
                'updatedAt',
                'endDate',
                'customer',
                'amountPrice',
                'details',
                'status',
                'payment',
                'store',
              ].includes(data.key)
          ), (item, i) => {
          return {
            name: `cell-${item.key}`,
            fn: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
            ])
          }
        })
      ]), 1032, ["table-header", "table-data", "loading", "total"])
    ]),
    _createVNode(_component_ConfirmModal, {
      ref: "modelRef",
      idProps: "refund-modal",
      message: "Are you sure you want to refund this order?"
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.refundOrder && $setup.refundOrder(...args))),
          "data-bs-toggle": "modal",
          "data-bs-target": "#refund-modal",
          type: "button",
          name: "confirm",
          class: "btn btn-primary px-10"
        }, " Refund ")
      ]),
      _: 1
    }, 512)
  ]))
}